import { connectBaseApi, createRpcQuery, createRpcMutation, shiftPlanClient } from "@racoon/api";

const shiftPlanApi = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listShiftSchedule: createRpcQuery(build, shiftPlanClient, "listShiftSchedule", {
      providesTags: ["ShiftPlan"],
    }),

    createShiftPlan: createRpcMutation(build, shiftPlanClient, "createShiftPlan", {
      invalidatesTags: ["ShiftPlan"],
    }),

    deleteShiftPlan: createRpcMutation(build, shiftPlanClient, "deleteShiftPlan", {
      invalidatesTags: ["ShiftPlan"],
    }),
  }),
  overrideExisting: false,
});

export const { useListShiftScheduleQuery, useCreateShiftPlanMutation, useDeleteShiftPlanMutation } =
  shiftPlanApi;
